import { makeApi } from "@zodios/core";
import { z } from "zod";

import { operationDtoSchema } from "@/types/backoffice/dto/operation/operation-dto.ts";
import { personDtoSchema } from "@/types/backoffice/dto/person/person-dto.ts";

export const backofficeOperatorApi = makeApi([
  {
    method: "get",
    path: "/me",
    response: personDtoSchema,
    alias: "getMe",
  },
  {
    method: "get",
    path: "/operations",
    response: z.array(operationDtoSchema),
    alias: "findOperations",
    parameters: [
      {
        type: "Query",
        name: "isOpened",
        schema: z.boolean().nullish(),
      },
    ],
  },
]);
